import React from "react";
import { Container, Grid } from "@mui/material";
import styled from "@emotion/styled";
import SectionsHeading from "../../SectionsHeading";
import Paragraph from "../../Paragraph";
import { FlexDiv, Image } from "../../../Styles/style";
import { PageWrapper } from "../../../Styles/style";
import LockerMenu from "../../../Components/LockerMenu/index";
const ContinerWraper = styled(Container)`
  background: linear-gradient(to top, #050c24, transparent);
  min-height: calc(100vh);
  width: 100%;
  padding: 0 !important;
`;

const GridWraper = styled(Grid)`
  min-height: calc(100vh);
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  @media (max-width: 599px) {
    /* align-items: center; */
    padding-bottom: 50px;
  }
`;

const HeroSection = () => {
  return (
    <PageWrapper id="home">
      <LockerMenu />
      <ContinerWraper maxWidth="xxl">
        <Container>
          <GridWraper container>
            <Grid item xs={12} sm={6}>
              <SectionsHeading  data-aos="zoom-in">Moon Race</SectionsHeading>
              <Paragraph
                p="5px 50px 5px 0"
                p599="5px 0"
                data-aos="fade-up"
              >
                Embark on a journey with us into the exciting world of
                decentralized finance and cutting-edge blockchain technology.
                Moonracer is not just another crypto project; it's a bold vision
                that redefines how tokens can create value and opportunities for
                our community.
              </Paragraph>
              <FlexDiv data-aos="fade-up">
                <a href="https://t.me/moonracerfinance" target="blank">
                  <Image w599="30px" src="./Images/telegram.png" />
                </a>
                <a href="https://twitter.com/moonracercoin" target="blank">
                  <Image w599="30px" src="./Images/twiter.png" />
                </a>
                <a href="#home" target="blank">
                  <Image w599="30px" src="./Images/etherscan.png" />
                </a>
                <a href="#home" target="blank">
                  <Image w599="30px" src="./Images/dextool.png" />
                </a>
              </FlexDiv>
            </Grid>
          </GridWraper>
        </Container>
      </ContinerWraper>
    </PageWrapper>
  );
};

export default HeroSection;
